import React from 'react';
import _ from 'lodash';

import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import SocialProfilesBasicInfoComponent from './social-profiles-basic-info.component';
import SocialProfileMappedInfoComponent from './social-profile-mapped-info.component';

export const SocialProfilesComponent = ({
    selectedSocialProfiles,
    socialProfileType,
    templates,
    tenantFunctions,
    handleFormItemChange,
    deleteSelectedFunctions,
    handleProductSearch,
    handleDeliverySearch,
    handleTierPriceSearch,
    handleCollectionPolicySearch,
    handleRewardPointSearch,
    handleDiscountSearch,
    handleVendorSearch,
    handleTopicSearch,
    handleModuleSearch,
    handleLearningPathSearch,
    handleCourseSearch,
    handleCollectionSearch,
    handleChannelSearch,
    handleCertificateSearch,
    handleAnnouncementSearch,
    handleCategorySearch,
    products,
    deliveries,
    collectionPolicies,
    tierPrices,
    rewards,
    discounts,
    organizationUnits,
    vendors,
    topics,
    modules,
    learningPaths,
    courses,
    collections,
    channels,
    certificates,
    announcements,
    categories,
    selectedFunctions,
    selectedTemplate,
    handleInnerFormChange,
    back,
    handleFormSubmit,
    changeImage,
    mediaFiles,
    accounts
}: any) => {
    const tabItems = [

        {
            id: 1,
            title: 'Basic Information',
            component: <SocialProfilesBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedSocialProfiles={selectedSocialProfiles}
                socialProfileType={socialProfileType}
            />,
            isVisible: true,
        },

        {
            id: 2,
            title: 'Mapped Entities',
            component: <SocialProfileMappedInfoComponent
                templates={templates}
                tenantFunction={tenantFunctions}
                selectedFunctions={selectedFunctions}
                categories={categories}
                deleteSelectedFunctions={deleteSelectedFunctions}
                handleInnerFormChange={handleInnerFormChange}
                handleFormItemChange={handleFormItemChange}
                announcements={announcements}
                // certificates={certificates}
                channels={channels}
                // collections={collections}
                // courses={courses}
                // learningPaths={learningPaths}
                // modules={modules}
                topics={topics}
                // vendors={vendors}
                organizationUnits={organizationUnits}
                discounts={discounts}
                rewards={rewards}
                tierPrices={tierPrices}
                collectionPolicies={collectionPolicies}
                deliveries={deliveries}
                products={products}
                handleCategorySearch={handleCategorySearch}
                handleAnnouncementSearch={handleAnnouncementSearch}
                // handleCertificateSearch={handleCertificateSearch}
                handleChannelSearch={handleChannelSearch}
                // handleCollectionSearch={handleCollectionSearch}
                // handleCourseSearch={handleCourseSearch}
                // handleLearningPathSearch={handleLearningPathSearch}
                // handleModuleSearch={handleModuleSearch}
                handleTopicSearch={handleTopicSearch}
                // handleVendorSearch={handleVendorSearch}
                handleDiscountSearch={handleDiscountSearch}
                handleRewardPointSearch={handleRewardPointSearch}
                handleCollectionPolicySearch={
                    handleCollectionPolicySearch
                }
                handleTierPriceSearch={handleTierPriceSearch}
                handleDeliverySearch={handleDeliverySearch}
                handleProductSearch={handleProductSearch}
                accounts={accounts}
            />,
            isVisible: true,
        },

    ]

    return (
        <>



            <TabContainer tabItems={tabItems} />



            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>

        </>
    );
};
export default SocialProfilesComponent;
